import styled from 'styled-components';
import React from 'react';
import { layout } from 'styles/layout';
import { BaseConfetti } from 'elements/confetti/confetti.styles'

export const ConfettiContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
`

export const ConfettiElement1 = styled(BaseConfetti).attrs({
  width: 24,
  height: 38,
  viewBox: '0 0 24 38',
  children: <path d="M19.3713 37.4744L23.7889 2.56197L9.82397 0.794923L0.569806 7.97017L19.3713 37.4744Z" fill="#1cabbf" />
})`
  top: 2%;
  right: 5%;
  transform: rotate(120deg) scale(.65);;

  @media screen and (min-width: ${layout.subLg}) {
    top: 42px;
    right: 114px;
    transform: rotate(120deg);
  }
`

export const ConfettiElement2 = styled(BaseConfetti).attrs({
  width: 25,
  height: 20,
  viewBox: '0 0 25 20',
  children: <path d="M3.04392 1.99999L16.6609 17.7493L22.9606 12.3025L23.4623 5.39275L3.04392 1.99999Z" stroke="#e7b556" strokeWidth="2"/>
})`
  top: 19%;
  left: 4%;
  transform: rotate(-91deg) scale(.85);

  @media screen and (min-width: ${layout.subLg}) {
    top: 27%;
    left: 24px;
    top: 150px;
    transform: rotate(-91deg);
  }
`
